"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ajaPathFill = exports.getImgSource = exports.getWeatherClass = void 0;
const helpers_1 = require("./helpers");
function getWeatherClass(weatherInfo, venueInfo) {
    // we will use this variable to change the class depending on the weather in order to change the background of the page
    let weatherClass = "";
    const sunsetOfToday = helpers_1.Helpers.getHourFromDate(weatherInfo.forecast[0].sunset);
    const sunriseOfTomorrow = helpers_1.Helpers.getHourFromDate(weatherInfo.forecast[1].sunrise);
    const timeNow = helpers_1.Helpers.convertDateToTimezone(new Date().toISOString(), venueInfo.timezone, { hour: "2-digit", minute: "2-digit", hour12: false });
    switch (weatherInfo.current.symbol) {
        case "rain":
        case "partly_cloudy_day":
        case "cloudy":
        case "thunderstorms":
        case "mostly_cloudy_day":
        case "mist":
        case "hail":
        case "drizzle":
        case "sun_showers":
        case "scattered_thunderstorms":
            weatherClass = "rain";
            break;
        case "snow":
        case "sleet":
        case "flurries":
            weatherClass = "snow";
            break;
        case "clear_night":
        case "partly_cloudy_night":
        case "mostly_cloudy_night":
            weatherClass = "night";
            break;
        case "clear_day":
            weatherClass = "sunny";
            break;
        default:
            weatherClass = "snow";
    }
    if (timeNow > sunsetOfToday && timeNow < sunriseOfTomorrow) {
        weatherClass = "night";
    }
    return weatherClass;
}
exports.getWeatherClass = getWeatherClass;
function getImgSource(brandSlug) {
    if (brandSlug === "ajaresorts") {
        return "aja";
    }
    return "general";
}
exports.getImgSource = getImgSource;
const ajaPathFill = [
    "clear_night",
    "mostly_cloudy_night",
    "partly_cloudy_night",
    "scattered_thunderstorms",
    "thunderstorms",
];
exports.ajaPathFill = ajaPathFill;
